import type { AuthResponse } from "@redchain/contracts";
import type { Wallet, WalletAccount } from "@wallet-standard/base";
import type { GameWallet } from "../types";
import { relaySignTransaction, signInCustodial } from "./api";

/**
 * Custodial `GameWallet` (§8.1). `address` is the game account.
 * `signIn` uses the connected wallet against /custody/nonce and /custody/verify.
 * `signTransaction` posts CustodySignRequest to /custody/sign.
 */
export function custodialGameWallet(wallet: Wallet, account: WalletAccount, gameAccount: string): GameWallet {
  return {
    address: gameAccount,
    connectedAddress: account.address,
    kind: "external",
    signIn: () => signInCustodial(wallet, account),
    signTransaction: (bytes) => relaySignTransaction(wallet, account, gameAccount, bytes),
  };
}

export function gameAccountFromAuth(res: AuthResponse, fallback: string): string {
  return res.wallet || fallback;
}
